import { api } from "@/lib/api";
import { ENDPOINTS } from "@/constants/endpoint";
import {
  detectPlatform,
  getPlatformDisplayName,
  extractCleanHostname,
  SOURCE_PLATFORM_LABELS as PLATFORM_LABELS_REGISTRY,
} from "@/lib/thirdPartyPlatforms";

export const TPE_GO_STORAGE_KEY = "tykkit_tpe_go";

export const SOURCE_PLATFORM_LABELS = PLATFORM_LABELS_REGISTRY;

export function thirdPartyGoUrl(eventId) {
  return `/redirect/${encodeURIComponent(eventId)}`;
}

export function saveThirdPartyGoPayload(payload) {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(TPE_GO_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // private mode / quota
  }
}

export function readThirdPartyGoPayload(eventId) {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(TPE_GO_STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || (data.eventId && data.eventId !== eventId)) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function sourcePlatformLogoUrl(value) {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) {
    return value[0]?.url || value[0]?.thumbnail || "";
  }
  if (typeof value === "object") {
    return value.url || value.thumbnail || "";
  }
  return "";
}

export function sourcePlatformLabel(sourcePlatform) {
  if (!sourcePlatform) return "booking site";
  return getPlatformDisplayName({ sourcePlatform });
}

export function bookingHostLabel(url) {
  return extractCleanHostname(url);
}

export { detectPlatform, getPlatformDisplayName };

export async function requestThirdPartyRedirect({ eventId, name, mobile, showId }) {
  const { data } = await api.post(
    ENDPOINTS.THIRD_PARTY_EVENT_REDIRECT.replace(":id", eventId),
    {
      ...(name ? { name } : {}),
      ...(mobile ? { mobile } : {}),
      // The date/venue picked on a multi-show listing has its own link.
      ...(showId ? { show_id: showId } : {}),
    },
  );

  if (!data?.status) {
    throw new Error(data?.message || "Unable to continue to booking.");
  }

  const redirectUrl = data?.data?.redirect_url;
  if (!redirectUrl) {
    throw new Error("Booking URL is missing.");
  }

  return {
    redirectUrl,
    sourcePlatform: data?.data?.source_platform,
    sourcePlatformLogo: data?.data?.source_platform_logo || null,
  };
}
